import { extends as _extends } from '../../../_virtual/_rollupPluginBabelHelpers.js';
import * as React from 'react';

const SvgEmail24 = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 24,
  height: 24,
  fill: "currentColor",
  "aria-label": "Email",
  viewBox: "0 0 24 24"
}, props), /*#__PURE__*/React.createElement("path", {
  d: "M21.25 4H2.75a.75.75 0 0 0-.75.75v14.5c0 .414.336.75.75.75h18.5a.75.75 0 0 0 .75-.75V4.75a.75.75 0 0 0-.75-.75m-.75 1.5v.315L12 11.631 3.5 5.815V5.5zm-17 13V7.633l8.077 5.526a.75.75 0 0 0 .846 0L20.5 7.633V18.5z"
}));

export { SvgEmail24 as default };
//# sourceMappingURL=Email24.js.map
